<script>
export default {
  props: {
    isVisible: { type: Boolean },
    markers: { type: Array },
    colors: { type: Object },
  },
};
</script>

<template>
  <Transition name="slide-fade">
    <div v-if="isVisible" class="legend-container">
      <div v-for="(marker, index) in markers" :key="index" class="legend-item">
        <h6 class="legend-text">
          {{ marker }}
        </h6>
        <div
          class="legend-stroke"
          :style="{ background: colors[marker] }"
        />
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.legend-container {
  pointer-events: none;
  position: absolute;
  top: 20px;
  right: 5px;
  padding: 5px 12px;
  display: flex;
  flex-direction: column;
  background: rgba(179, 221, 253, 0.2);
  border-radius: 5px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(179, 221, 253, 0.3);
  box-sizing: border-box;
}

.legend-item {
  width: 100%;
  display: grid;
  grid-template-columns: auto 40px;
  align-items: center;
  gap: 5px;
  box-sizing: border-box;
}

.legend-text {
  font-weight: 400;
  text-align: right;
}

.legend-stroke {
  width: 40px;
  height: 3px;
  border-radius: 20px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
